import React, { useState } from 'react'
import PageHeader from '../../components/PageHeader/PageHeader'
import { Button, Form, Input, Select, message, notification } from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { ReadCookie } from '../../utils/readCookie';
import Loader from "react-loader-spinner";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { getAmazonProductUpdate, updateAmazonProductUpdate } from '../../redux/actions/amazonProductInformation.action';
import "./AmazonProductUpdate.css"

const AmazonProductUpdate = () => {
    const [form] = Form.useForm();
    const { productUpdate } = useSelector((state) => state);
    const dispatch = useDispatch();
    const token = ReadCookie("token");
    const [loading, setLoading] = useState(false);
    const [updateloading, setUpdateLoading] = useState(false);




    const onFinish = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();

            form.resetFields([
                "style",
                "amazon_description",
                "description_1",
                "description_2",
                "description_3",
                "description_4",
                "description_5",
                "color_map",
            ]);

            const res = await dispatch(getAmazonProductUpdate(token, values));

            if (res.payload.data && res.payload.data.length > 0) {
                const data = res.payload.data[0];
                form.setFieldsValue({
                    style: data.style_name,
                    amazon_description: data.amazon_product_description,
                    description_1: data.amazon_bullet_point1,
                    description_2: data.amazon_bullet_point2,
                    description_3: data.amazon_bullet_point3,
                    description_4: data.amazon_bullet_point4,
                    description_5: data.amazon_bullet_point5,
                    color_map: data.amazon_color_map,
                });
            } else {
                // Notification for empty data
                notification.info({
                    message: 'No Record',
                    description: 'No record available for the selected product.',
                    placement: 'topRight',
                    duration: 2, // auto close after 3 seconds
                });
            }

        } catch (error) {
            console.error(error);
            notification.error({
                message: 'Error',
                description: 'Something went wrong while fetching the product.',
                placement: 'topRight',
                duration: 2,
            });
        } finally {
            setLoading(false); // loader hamesha false
        }
    };

    const handleUpdate = async (ParentItemID) => {
        if (!ParentItemID) {
            notification.error({
                message: "Error",
                description: "No ParentItemID found to update.",
            });
            return;
        }

        setUpdateLoading(true);

        try {
            const values = await form.validateFields();

            const selectedValues = {
                amazon_product_description: values.amazon_description || null,
                amazon_bullet_point1: values.description_1 || null,
                amazon_bullet_point2: values.description_2 || null,
                amazon_bullet_point3: values.description_3 || null,
                amazon_bullet_point4: values.description_4 || null,
                amazon_bullet_point5: values.description_5 || null,
                amazon_color_map: values.color_map || null,
            };

            const res = await dispatch(updateAmazonProductUpdate(token, ParentItemID, selectedValues));

            if (res?.payload?.success) {
                notification.success({
                    message: "Update Successful",
                    description: "Amazon product data has been updated successfully.",
                });
            } else {
                notification.error({
                    message: "Update Failed",
                    description: "Something went wrong while updating the product.",
                });
            }

            // Clear the fields after update
            form.resetFields([
                "style",
                "amazon_description",
                "description_1",
                "description_2",
                "description_3",
                "description_4",
                "description_5",
                "color_map",
            ]);

        } catch (err) {
            notification.error({
                message: err.errorFields ? "Validation Failed" : "Error",
                description: err.errorFields
                    ? "Please check the form fields and try again."
                    : "An error occurred while updating the product.",
            });
        } finally {
            setUpdateLoading(false);
        }
    };




    return (
        <div className="styleContainer">
            <div className="styleBody h-100">
                <PageHeader
                    title={"Amazon Product Update"}
                    minimize={false}
                    check={false}
                />
                {loading ?
                    <div className='loaderDiv' >
                        <Loader
                            type="Grid"
                            color="#212121"
                            height={50}
                            width={50}
                        />
                    </div> :
                    null}

                <div className="bodyStyle">
                    <div className="row">
                        <div className="col" style={{ margin: 10 }}>
                            <Form
                                form={form}
                                name="control-hooks"
                                onFinish={onFinish}
                            >
                                <Brow>
                                    <Bcol md={12} xl={18} xxl={20} className="pbpx-10">
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="firstSectionRo amazon-inputs">
                                                    <Form.Item
                                                        name="sku"
                                                        label="SKU"
                                                        labelAlign="left"
                                                        labelCol={{ span: 10 }}
                                                        // wrapperCol={{ span: 10 }}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select SKU",
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="Enter SKU"
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <Button
                                                    htmlType="submit"
                                                    type="primary"
                                                >
                                                    Submit
                                                </Button>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="firstSectionRo amazon-inputs">
                                                    <Form.Item
                                                        name="style"
                                                        label="Style"
                                                        labelAlign="left"
                                                        labelCol={{ span: 10 }}
                                                    // wrapperCol={{ span: 9 }}
                                                    >
                                                        <Input disabled style={{
                                                            color: "#000",
                                                            backgroundColor: "#f5f5f5",
                                                            opacity: 1,
                                                        }} />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={4} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="amazon_description"
                                                        label="Product Description:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={6} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="description_1"
                                                        label="Bullet Point 1:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={4} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="description_2"
                                                        label="Bullet Point 2:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={4} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="description_3"
                                                        label="Bullet Point 3:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={4} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="description_4"
                                                        label="Bullet Point 4:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={4} xxl={6}>
                                                <div className="firstSectionRo">
                                                    <Form.Item
                                                        name="description_5"
                                                        label="Bullet Point 5:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 5 }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                        </Brow>
                                        <Brow className={"mb-1"}>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <div className="firstSectionRo amazon-inputs">
                                                    <Form.Item
                                                        name="color_map"
                                                        label="Color Map:"
                                                        labelAlign="left"
                                                        labelCol={{ span: 10 }}
                                                    >
                                                        <Input
                                                            size="medium"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            </Bcol>
                                            <Bcol lg={6} xl={4} xxl={3}>
                                                <Button
                                                    onClick={() => handleUpdate(productUpdate?.payload?.data?.[0]?.parent_item_id)}
                                                    type="primary"
                                                    loading={updateloading}
                                                    disabled={!(productUpdate?.payload?.data?.length > 0) || updateloading || !form.getFieldValue("style")}
                                                >
                                                    Update
                                                </Button>
                                            </Bcol>
                                        </Brow>
                                    </Bcol>
                                </Brow>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AmazonProductUpdate